import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PtoventaService } from 'app/services/ptoventa.service';

@Component({
  selector: 'app-apertura',
  templateUrl: './apertura.component.html',
  styleUrls: ['./apertura.component.css']
})
export class AperturaComponent implements OnInit {

  form: UntypedFormGroup;
  lstPuntoVentas = [];
  selectedReceiptBooks = [];
  noReceiptBooksAvailable = false;

  constructor(
    public dialogRef: MatDialogRef<AperturaComponent>,
    private fb: UntypedFormBuilder,
    private ptoVentaService: PtoventaService,
    private snackBar: MatSnackBar,
    ) {
      this.form = this.fb.group({
        montoCtrl: ['0', Validators.required],
        puntoventa: ['', Validators.required],
        receiptBook: [{ value: '', disabled: true }, Validators.required]
      });
    }

  ngOnInit(): void {
    this.getPuntosVentas();
  }

  getPuntosVentas() {
    this.ptoVentaService.getAllWithReceiptBooks().subscribe(
      (data) => {
        this.lstPuntoVentas = data;
      },
      err => {
        console.log(err);
      }
    )
  }

  onPuntoVentaChange(puntoVentaId: number) {
    if (puntoVentaId) {
      // Deshabilitar el select de talonarios mientras se cargan los datos
      this.form.get('receiptBook').disable();
      this.form.get('receiptBook').setValue('');
      this.noReceiptBooksAvailable = false;
      
      // Obtener los talonarios desde el endpoint específico
      this.ptoVentaService.getReceiptBooksBySalesPoint(puntoVentaId, true).subscribe(
        (receiptBooks) => {
          this.selectedReceiptBooks = receiptBooks || [];
          
          if (this.selectedReceiptBooks.length > 0) {
            // Habilitar el select y seleccionar automáticamente el primer receiptBook
            this.form.get('receiptBook').enable();
            this.form.get('receiptBook').setValue(this.selectedReceiptBooks[0].id);
            this.noReceiptBooksAvailable = false;
          } else {
            // Si no hay talonarios, mantener deshabilitado y mostrar mensaje
            this.form.get('receiptBook').disable();
            this.noReceiptBooksAvailable = true;
          }
        },
        (error) => {
          console.error('Error al obtener talonarios:', error);
          this.selectedReceiptBooks = [];
          this.form.get('receiptBook').disable();
          this.form.get('receiptBook').setValue('');
          this.noReceiptBooksAvailable = true;
          this.openSnackBar('Error al cargar los talonarios del punto de venta');
        }
      );
    } else {
      // Si no hay punto de venta seleccionado, deshabilitar y limpiar
      this.selectedReceiptBooks = [];
      this.form.get('receiptBook').disable();
      this.form.get('receiptBook').setValue('');
      this.noReceiptBooksAvailable = false;
    }
  }

  openSnackBar(message: string) {
    this.snackBar.open(message, "error", {
      duration: 4000,
    });
  }

  guardarCaja() {
    // Validar que hay talonarios disponibles
    if (this.noReceiptBooksAvailable || this.selectedReceiptBooks.length === 0) {
      this.openSnackBar('No se puede abrir la caja sin talonarios asociados al punto de venta');
      return;
    }

    // Validar que el formulario es válido
    if (this.form.invalid) {
      this.openSnackBar('Por favor complete todos los campos requeridos');
      return;
    }

    // Habilitar temporalmente el campo receiptBook para obtener su valor
    const receiptBookControl = this.form.get('receiptBook');
    const wasDisabled = receiptBookControl.disabled;
    
    if (wasDisabled) {
      receiptBookControl.enable();
    }
    
    this.dialogRef.close({
      monto: this.form.controls.montoCtrl.value,
      puntoventa: this.form.controls.puntoventa.value,
      receiptBook: this.form.controls.receiptBook.value
    });
  }

  cancelar() {
    this.dialogRef.close();
  }

}
